import { GROUP_CONFIGURATION_PATH } from "common/constants";
import ExtraDetailsDrawer from "common/ExtraDetails/ExtraDetailsDrawer";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { getRouteWithoutPath } from "utils/routes";
import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import UserGroupSummary from "features/configuration/GroupConfigurationDrawer/UserGroupSummary";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";

const GroupConfigurationDrawer = () => {
  const match = useRouteMatch(GROUP_CONFIGURATION_PATH);
  const { subGroupId: subGroupIdStr } = (match?.params || {}) as {
    subGroupId: string;
  };

  return (
    <DrawerContent
      subGroupId={subGroupIdStr ? parseInt(subGroupIdStr) : undefined}
    />
  );
};

export default GroupConfigurationDrawer;

interface DrawerContentProps {
  subGroupId?: number;
}

const DrawerContent = ({ subGroupId }: DrawerContentProps) => {
  const history = useHistory();
  const groupData = undefined;
  const isLoading = false;

  const closeDrawer = () => {
    history.push(
      getRouteWithoutPath(location.pathname, GROUP_CONFIGURATION_PATH)
    );
  };

  const content = (
    <LoadingSpinnerOverlay
      isLoading={isLoading}
      hideContentWhileLoading={true}
      spinnerSize="large"
      spinnerMarginTop={100}
    >
      {groupData && (
        <UserGroupSummary groupData={groupData} style={{ marginBottom: 20 }} />
      )}
    </LoadingSpinnerOverlay>
  );

  return (
    <ExtraDetailsDrawer
      visible={!!subGroupId}
      closeDrawer={closeDrawer}
      title={
        <Flex $justifyContent="center">
          <Text>Group Configuration</Text>
        </Flex>
      }
      content={content}
    />
  );
};
